import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import PublisherLayout from "layouts/Publisher.js";
import { CancelRequestProvider } from "variables/cancelrequest";
import { LoadingProvider } from "components/Loader/loader";
import NotFound from "./404.js";
import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";

ReactDOM.render(
  <ErrorBoundary>
    <BrowserRouter >
      <CancelRequestProvider>
        <LoadingProvider>
          <Switch>
            <Route path="/auth/*" component={AuthLayout} />
            <Route path="/publisher/*" component={AdminLayout} />
            <Route path="/advertiser/*" component={PublisherLayout} />
            <Redirect from="/" to="/auth/signin" />
            <Route path="/404" component={NotFound} />
            <Redirect to="/404" />
          </Switch>
        </LoadingProvider>
      </CancelRequestProvider>
    </BrowserRouter>
  </ErrorBoundary>,
  document.getElementById("root")
);
